// src/context/ToastProvider.js
import React, { createContext, useContext } from "react";
import { Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastContext = createContext();
/**
 * don't use loading to updateToastPromise and create toast
 */
export const TOAST_TYPE = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warn',
    ERROR: 'error',
    DEFAULT: 'default',
    LOADING: 'loading',
}

export const updateToastPromise = (id, message, type = TOAST_TYPE.DEFAULT) => {
    const configToast = {
        render: message,
        type: type,
        isLoading: false
    }
    switch (type) {
        case TOAST_TYPE.SUCCESS:
            configToast.autoClose = 1000
            break;
        case TOAST_TYPE.WARNING:
            configToast.isLoading = true
            break;
        case TOAST_TYPE.ERROR:
            configToast.autoClose = 1000
            break;
        case TOAST_TYPE.INFO:
            configToast.isLoading = true
            configToast.autoClose = false
            break;
        default:
            configToast.autoClose = 0
            break;
    }
    toast.update(id, configToast);
}

export const ToastProvider = ({ children }) => {
    const showToast = (message, type = "success") => {
        toast[type](message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            transition: Slide,
        });
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <ToastContainer position="top-right" autoClose={3000} />
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);
